import type { RefObject } from "react";
import { useIntl } from "react-intl";
import { OrganizationalRecordPanel } from "./OrganizationalRecordPage";
import type { OrganizationalRecordSubject } from "./organizational-record-subject";
import type { OrganizationalRecordAccess } from "./use-organizational-record-access";
import { ORGANIZATIONAL_RECORD_ANCHOR } from "./use-organizational-record-section";

/** The record under a page, mounted only while open and remounted per subject, so nothing of one subject's file survives a switch. */
export function OrganizationalRecordSection({ expanded, sectionRef, subject, access }: {
  expanded: boolean; sectionRef: RefObject<HTMLElement | null>; subject: OrganizationalRecordSubject; access: OrganizationalRecordAccess;
}) {
  const intl = useIntl();
  if (!expanded) return null;
  // Keep enough scrollable space for the anchor even when the record is empty.
  return <section key={`${subject.kind}:${subject.id}`} id={ORGANIZATIONAL_RECORD_ANCHOR} ref={sectionRef} tabIndex={-1}
    aria-label={intl.formatMessage({ id: "organizationalRecord.heading" })} className="mt-8 min-h-dvh scroll-mt-24 pb-40 outline-none">
    <OrganizationalRecordPanel subject={subject} access={access} />
  </section>;
}
